import {CoinsFeatureInfo} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/coins_feature_info.types';
import {Image, Text} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const CoinsFeatureInfos: React.FC<{
  className?: string;
  featureInfos: CoinsFeatureInfo[];
}> = ({className, featureInfos}) => {
  return (
    <Wrapper className={className}>
      {featureInfos.map((featureInfo, index) => {
        return (
          <Row key={index} data-testid="coinsWalletFeatureInfo">
            <Image
              src={featureInfo.icon.url}
              breakpoints={[]}
              ratio="1:1"
              widths={[24, 48]}
              width={24}
              height={24}
            />
            <TextWrapper>
              <StyledText size="px14" weight="mediumHeavy">
                {featureInfo.title}
              </StyledText>
              <StyledText size="px10" weight="mediumBold" color="Text.Grey">
                {featureInfo.description}
              </StyledText>
            </TextWrapper>
          </Row>
        );
      })}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const StyledText = styled(Text)`
  line-height: 1.5;
`;
